module.exports = __webpack_public_path__ + "static/media/icon3u.6cbf47e3.svg";